var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 60,
    height: 60,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.094 15.986l13.756-2.041c0.099 0.671 0.15 1.357 0.15 2.055 0 2.677-0.751 5.179-2.055 7.305l-11.857-7.241 11.891 7.264-0.634 0.876c-2.569 3.529-6.686 5.796-11.333 5.796-0.005 0-0.009 0-0.014 0h0.001c-7.732 0-14-6.268-14-14s6.268-14 14-14h1.072l-0.978 13.986zM29.434 12.048l-1.919 0.564c-0.2-0.676-0.423-1.247-0.686-1.796l0.031 0.072 1.809-0.853c0.306 0.65 0.562 1.323 0.765 2.014zM27.54 8.071l-1.647 1.134c-0.371-0.536-0.752-1.005-1.166-1.443l0.005 0.006 1.455-1.372c0.493 0.523 0.946 1.083 1.353 1.675zM24.612 4.962l-1.231 1.576c-0.486-0.38-1-0.721-1.538-1.022l0.975-1.746c0.685 0.385 1.271 0.78 1.824 1.215l-0.030-0.023zM20.715 2.814l-0.673 1.883c-0.494-0.184-1.091-0.352-1.705-0.473l-0.075-0.012 0.374-1.965c0.709 0.135 1.404 0.325 2.079 0.566zM4 16c0 6.627 5.373 12 12 12 3.527 0 6.797-1.532 9.050-4.119l-11.041-6.744 0.915-13.089c-6.123 0.544-10.924 5.688-10.924 11.952z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/Analysis.0ffece96690702d78e05c31c41522d56.svg";
export { ForwardRef as ReactComponent };